import React, { ChangeEvent } from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function TextInput(props: Props) {
  const input = ({
    target,
  }: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    !props.isDisabled &&
    (props.maxLength
      ? props.input(target.value.slice(0, props.maxLength))
      : props.input(target.value));

  return props.isMultiline ? (
    <textarea
      className={classNames(styles.textInput, {
        [styles.invalidTextInput]: props.isInvalid,
      })}
      disabled={props.isDisabled}
      value={props.isSecured ? props.value.replaceAll(/./g, "•") : props.value}
      placeholder={props.placeholder}
      onChange={input}
    />
  ) : (
    <input
      type={props.isSecured ? "password" : "text"}
      disabled={props.isDisabled}
      className={classNames(styles.textInput, {
        [styles.invalidTextInput]: props.isInvalid,
      })}
      placeholder={props.placeholder}
      value={props.value}
      onChange={input}
    />
  );
}

export { TextInput };
